import { render, staticRenderFns } from "./miniCalendarItem.vue?vue&type=template&id=10933e5a&scoped=true&"
import script from "./miniCalendarItem.vue?vue&type=script&lang=js&"
export * from "./miniCalendarItem.vue?vue&type=script&lang=js&"
import style0 from "./miniCalendarItem.vue?vue&type=style&index=0&id=10933e5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10933e5a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
